import { env } from 'next-runtime-env';

/** Release id for Datadog RUM + source maps. Set in CI to the git SHA used for upload. */
export const APP_VERSION =
  env('NEXT_PUBLIC_APP_VERSION') ||
  process.env.NEXT_PUBLIC_APP_VERSION ||
  '';

export const BASE_URL =
  env('NEXT_PUBLIC_BASE_URL') || process.env.NEXT_PUBLIC_BASE_URL || '';

export const EVA_API_URL =
  env('NEXT_PUBLIC_EVA_API_URL') || process.env.NEXT_PUBLIC_EVA_API_URL || '';
export const EVA_LOGGER_LEVEL =
  env('NEXT_PUBLIC_EVA_LOGGER_LEVEL') ||
  process.env.NEXT_PUBLIC_EVA_LOGGER_LEVEL ||
  '';
export const EVA_OPENID_PROVIDER_ID =
  env('NEXT_PUBLIC_EVA_OPENID_PROVIDER_ID') ||
  process.env.NEXT_PUBLIC_EVA_OPENID_PROVIDER_ID ||
  '';

export const GTM_ID =
  env('NEXT_PUBLIC_GTM_ID') || process.env.NEXT_PUBLIC_GTM_ID || '';
export const COOKIE_LAW_DOMAIN_SCRIPT =
  env('NEXT_PUBLIC_COOKIE_LAW_DOMAIN_SCRIPT') ||
  process.env.NEXT_PUBLIC_COOKIE_LAW_DOMAIN_SCRIPT ||
  '';

export const UNIFORM_API_URL =
  env('NEXT_PUBLIC_UNIFORM_API_URL') ||
  process.env.NEXT_PUBLIC_UNIFORM_API_URL ||
  '';
export const UNIFORM_API_KEY =
  env('NEXT_PUBLIC_UNIFORM_API_KEY') ||
  process.env.NEXT_PUBLIC_UNIFORM_API_KEY ||
  '';
export const UNIFORM_PROJECT_ID =
  env('NEXT_PUBLIC_UNIFORM_PROJECT_ID') ||
  process.env.NEXT_PUBLIC_UNIFORM_PROJECT_ID ||
  '';

/** Uniform Management/App API base (e.g. project-map endpoints). Falls back to US Management API when unset. */
export const UNIFORM_APP_API_URL =
  env('NEXT_PUBLIC_UNIFORM_APP_API_URL') ||
  process.env.NEXT_PUBLIC_UNIFORM_APP_API_URL ||
  '';
